const initialState = {
  searchDate: [null, null],
  accessKey: '',
  appId: '',
  appName: '',
  akskName: '',
};

export default {
  namespaced: true,
  state: {
    searchDate: [null, null],
    accessKey: '',
    appId: '',
    appName: '',
    akskName: '',
  },
  mutations: {
    updateState(state, payload) {
      Object.assign(state, payload);
    },
    clearState(state) {
      Object.assign(state, {
        ...initialState,
      });
    },
  },
  actions: {},
};
